import React, { useState, useEffect } from 'react'
import { SlideToggle } from 'react-slide-toggle'
import { isMobile } from 'react-device-detect'
import { find, findIndex, isEmpty, get } from 'lodash'
import { Input } from 'reactstrap'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'

const Filters = ({
  clearAll,
  showRangePrice,
  minPrice,
  maxPrice,
  setPriceRange,
  showSuppliers,
  suppliers,
  supplierChecked,
  showFamilies,
  families,
  familyChecked,
  showCategories,
  categories,
  categoryValue,
  setCategoryValue,
  categoryChecked,
  showSubcategories,
  subcategories,
  subcategoryChecked,
  showBrands,
  brands,
  brandChecked,
  showSearcher,
  searcher,
  setSearcher
}) => {
  const [value, setValue] = useState({ max: 1000, min: 0 })
  const [supplierValue, setSupplierValue] = useState([])
  const [brandValue, setBrandValue] = useState([])
  const [familyValue, setFamilyValue] = useState([])

  const [subcategoryValue, setSubcategoryValue] = useState([])

  const [toggle, setToggle] = useState(false)

  const [showFilter, setShowFilter] = useState(false)
  const toggleFilter = () => setShowFilter(!showFilter)

  useEffect(() => {
    setValue({ max: maxPrice, min: minPrice })
  }, [maxPrice, minPrice])

  useEffect(() => {
    window.addEventListener("resize", resizeHandle)
    resizeHandle()

    return () => {
      window.removeEventListener("resize", resizeHandle)
    }
  }, []) // eslint-disable-line

  const resizeHandle = () => {
    if (document.querySelector("body").offsetWidth < 992) {
      setToggle(true)
    } else {
      setToggle(false)
    }
  }

  const toggleSideBar = () => {
    if (document.querySelector('body').classList.contains('sidebar-filter-active')) {
      document.querySelector('body').classList.remove('sidebar-filter-active')
    } else {
      document.querySelector('body').classList.add('sidebar-filter-active')
    }
  }

  const hideSideBar = () => {
    if (document.querySelector('body').classList.contains('sidebar-filter-active')) {
      document.querySelector('body').classList.remove('sidebar-filter-active')
    }
  }

  const changeIcon = (e) => {
    e.target.classList.toggle('collapsed')
  }

  const clearFilters = (e) => {
    setValue({ max: maxPrice, min: minPrice })
    setSupplierValue([])
    setBrandValue([])
    setFamilyValue([])
    setCategoryValue([])
    setSubcategoryValue([])
    clearAll(e)
  }

  return (
    <>
      <aside
        className={`${toggle ? 'sidebar-filter' : 'sidebar'} sidebar-shop`}
        style={{ backgroundColor: 'white', padding: !isMobile ? '1rem' : '' }}
      >
        <div className={toggle ? 'sidebar-filter-wrapper' : ''}>
          <div className="widget widget-clean">
            <label>Filtros:</label>
            <a href="#a" className="sidebar-filter-clear" onClick={(e) => clearFilters(e)}>Limpiar todo</a>
          </div>

          {showSearcher && (
            <SlideToggle collapsed={ false }>
              {({ onToggle, setCollapsibleElement }) => (
                <div className="widget widget-collapsible">
                  <h3 className="widget-title">
                    <a href="#searcher" role="button" aria-expanded="true" aria-controls="widget-1"
                      onClick={(e) => {
                        onToggle(e)
                        changeIcon(e) 
                        e.preventDefault()
                      }}
                    >
                      Buscar productos
                    </a>
                  </h3>
                  <div ref={ setCollapsibleElement }>
                    <div className="widget-body">
                      <div className="filter-price">
                        <div className="price-slider">
                          <Input
                            type="text"
                            className="form-control"
                            required
                            value={searcher}
                            placeholder="Ingrese producto..."
                            onChange={event => setSearcher(event.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </SlideToggle>
          )}

          {showRangePrice && (
            <SlideToggle collapsed={ false }>
              {({ onToggle, setCollapsibleElement }) => (
                <div className="widget widget-collapsible">
                  <h3 className="widget-title">
                    <a href="#range" role="button" aria-expanded="true" aria-controls="widget-1"
                      onClick={(e) => {
                        onToggle(e)
                        changeIcon(e) 
                        e.preventDefault()
                      }}
                    >
                      Precio Vendora
                    </a>
                  </h3>
                  <div ref={ setCollapsibleElement }>
                    <div className="widget-body">
                      <div className="filter-price">
                        <div className="price-slider">
                          <InputRange
                            maxValue={maxPrice}
                            minValue={minPrice}
                            step={ 1 }
                            value={ value }
                            onChange={value => {
                              setValue(value)
                              setPriceRange(value)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </SlideToggle>
          )}

          {showSuppliers && (
            <SlideToggle collapsed={ false }>
              {({ onToggle, setCollapsibleElement }) => (
                <div className="widget widget-collapsible">
                  <h3 className="widget-title">
                    <a href="#supplier" role="button" aria-expanded="true" aria-controls="widget-1"
                      onClick={(e) => {
                        onToggle(e)
                        changeIcon(e)
                        e.preventDefault()
                      }}
                    >
                      Proveedores
                    </a>
                  </h3>
                  <div ref={ setCollapsibleElement }>
                    <div className="widget-body">
                      <div className="filter-items filter-items-count">
                        {
                          suppliers && suppliers.map( ( item, index ) =>
                            <div className="filter-item" key={ `supplier_${index}` }>
                              <div className="custom-control custom-checkbox">
                                <input
                                  checked={
                                    !isEmpty(supplierValue) &&
                                    get(find(supplierValue, { id: item.id }), 'checked', false)
                                  }
                                  type="checkbox"
                                  className="custom-control-input"
                                  id={`supplier-${index + 1}`}
                                  onClick={(e) => {
                                    toggleFilter(item.name)
                                  }}
                                  onChange={(e) => {
                                    const newSupplierValue = supplierValue
                                    const indexItem = findIndex(newSupplierValue, { id: item.id })
                                    if (indexItem < 0) {
                                      newSupplierValue.push({ id: item.id, checked: e.target.checked })
                                    } else {
                                      newSupplierValue[indexItem].checked = e.target.checked
                                    }
                                    setSupplierValue([...newSupplierValue])
                                    supplierChecked(e, item)
                                  }}
                                />
                                <label className="custom-control-label" htmlFor={ `supplier-${index + 1}` }>{item.nombreComercial}</label>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </SlideToggle>
          )}

          {showBrands && (
            <SlideToggle collapsed={ false }>
              {({ onToggle, setCollapsibleElement }) => (
                <div className="widget widget-collapsible">
                  <h3 className="widget-title">
                    <a href="#brand" role="button" aria-expanded="true" aria-controls="widget-1"
                      onClick={(e) => {
                        onToggle(e)
                        changeIcon(e)
                        e.preventDefault()
                      }}
                    >
                      Marcas
                    </a>
                  </h3>
                  <div ref={ setCollapsibleElement }>
                    <div className="widget-body">
                      <div className="filter-items filter-items-count">
                        {
                          brands && brands.map( ( item, index ) =>
                            <div className="filter-item" key={ `brand_${index}` }>
                              <div className="custom-control custom-checkbox">
                                <input
                                  checked={
                                    !isEmpty(brandValue) &&
                                    get(find(brandValue, { id: item.id }), 'checked', false)
                                  }
                                  type="checkbox"
                                  className="custom-control-input"
                                  id={ `brand-${index + 1}` }
                                  onClick={(e) => toggleFilter(item.name)}
                                  onChange={(e) => {
                                    const newValues = brandValue
                                    const indexItem = findIndex(newValues, { id: item.id })
                                    if (indexItem < 0) {
                                      newValues.push({ id: item.id, checked: e.target.checked })
                                    } else {
                                      newValues[indexItem].checked = e.target.checked
                                    }
                                    setBrandValue([...newValues])
                                    brandChecked(e, item)
                                  }}
                                />
                                <label className="custom-control-label" htmlFor={ `brand-${index + 1}` }>{item.name}</label>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </SlideToggle>
          )}

          {showFamilies && (
            <SlideToggle collapsed={ false }>
              {({ onToggle, setCollapsibleElement }) => (
                <div className="widget widget-collapsible">
                  <h3 className="widget-title">
                    <a href="#families" role="button" aria-expanded="true" aria-controls="widget-1"
                      onClick={(e) => {
                        onToggle(e)
                        changeIcon(e)
                        e.preventDefault()
                      }}
                    >
                      Familias
                    </a>
                  </h3>
                  <div ref={ setCollapsibleElement }>
                    <div className="widget-body">
                      <div className="filter-items filter-items-count">
                        {
                          families && families.map( ( item, index ) =>
                            <div className="filter-item" key={ `families_${index}` }>
                              <div className="custom-control custom-checkbox">
                                <input
                                  checked={
                                    !isEmpty(familyValue) &&
                                    get(find(familyValue, { id: item.id }), 'checked', false)
                                  }
                                  type="checkbox"
                                  className="custom-control-input"
                                  id={ `families-${index + 1}` }
                                  onClick={(e) => toggleFilter(item.name)}
                                  onChange={(e) => {
                                    const newValues = familyValue
                                    const indexItem = findIndex(newValues, { id: item.id })
                                    if (indexItem < 0) {
                                      newValues.push({ id: item.id, checked: e.target.checked })
                                    } else {
                                      newValues[indexItem].checked = e.target.checked
                                    }
                                    setFamilyValue([...newValues])
                                    familyChecked(e, item)
                                  }}
                                />
                                <label className="custom-control-label" htmlFor={ `families-${index + 1}` }>{item.name}</label>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </SlideToggle>
          )}

          {showCategories && (
            <SlideToggle collapsed={ false }>
              {({ onToggle, setCollapsibleElement }) => (
                <div className="widget widget-collapsible">
                  <h3 className="widget-title">
                    <a href="#categories" role="button" aria-expanded="true" aria-controls="widget-1"
                      onClick={(e) => {
                        onToggle(e)
                        changeIcon(e)
                        e.preventDefault()
                      }}
                    >
                      Categorías
                    </a>
                  </h3>
                  <div ref={ setCollapsibleElement }>
                    <div className="widget-body">
                      <div className="filter-items filter-items-count">
                        {
                          categories && categories.map( ( item, index ) =>
                            <div className="filter-item" key={ `categories_${index}` }>
                              <div className="custom-control custom-checkbox">
                                <input
                                  checked={
                                    !isEmpty(categoryValue) &&
                                    get(find(categoryValue, { id: item.id }), 'checked', false)
                                  }
                                  type="checkbox"
                                  className="custom-control-input"
                                  id={ `categories-${index + 1}` }
                                  onClick={(e) => toggleFilter(item.name)}
                                  onChange={(e) => {
                                    const newValues = categoryValue
                                    const indexItem = findIndex(newValues, { id: item.id })
                                    if (indexItem < 0) {
                                      newValues.push({ id: item.id, checked: e.target.checked })
                                    } else {
                                      newValues[indexItem].checked = e.target.checked
                                    }
                                    setCategoryValue([...newValues])
                                    categoryChecked(e, item)
                                  }}
                                />
                                <label className="custom-control-label" htmlFor={ `categories-${index + 1}` }>{item.name}</label>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </SlideToggle>
          )}

          {showSubcategories && (
            <SlideToggle collapsed={ false }>
              {({ onToggle, setCollapsibleElement }) => (
                <div className="widget widget-collapsible">
                  <h3 className="widget-title">
                    <a href="#subcategories" role="button" aria-expanded="true" aria-controls="widget-1"
                      onClick={(e) => {
                        onToggle(e)
                        changeIcon(e)
                        e.preventDefault()
                      }}
                    >
                      Subcategorías
                    </a>
                  </h3>
                  <div ref={ setCollapsibleElement }>
                    <div className="widget-body">
                      <div className="filter-items filter-items-count">
                        {
                          subcategories && subcategories.map( ( item, index ) =>
                            <div className="filter-item" key={ `subcategories_${index}` }>
                              <div className="custom-control custom-checkbox">
                                <input
                                  checked={
                                    !isEmpty(subcategoryValue) &&
                                    get(find(subcategoryValue, { id: item.id }), 'checked', false)
                                  }
                                  type="checkbox"
                                  className="custom-control-input"
                                  id={ `subcategories-${index + 1}` }
                                  onClick={(e) => toggleFilter(item.name)}
                                  onChange={(e) => {
                                    const newValues = subcategoryValue
                                    const indexItem = findIndex(newValues, { id: item.id })
                                    if (indexItem < 0) {
                                      newValues.push({ id: item.id, checked: e.target.checked })
                                    } else {
                                      newValues[indexItem].checked = e.target.checked
                                    }
                                    setSubcategoryValue([...newValues])
                                    subcategoryChecked(e, item)
                                  }}
                                />
                                <label className="custom-control-label" htmlFor={ `subcategories-${index + 1}` }>{item.name}</label>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </SlideToggle>
          )}

        </div>
      </aside>
      { toggle ?
        <button className="sidebar-fixed-toggler" onClick={toggleSideBar}>
          <i className="mdi mdi-filter"></i>
        </button>
        : ''
      }
      <div className="sidebar-filter-overlay" onClick={hideSideBar}></div>
    </>
  )
}

Filters.defaultProps = {
  showRangePrice: true,
  showFamilies: true,
  showCategories: true,
  showSubcategories: true,
  showBrands: true,
  showSuppliers: true
}

export default Filters
